module.exports = __webpack_public_path__ + "img/icon_map_11_off_011.ad6f8b44.png";